import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';
import {Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {BaseService} from './BaseService';
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner'
import 'rxjs/add/operator/map';
import {of} from 'rxjs/observable/of';
import {tap} from 'rxjs/operators';


@Injectable()
export class SealService {



    constructor(private http: HttpClient, private baseurl: BaseService, private spinnerService: Ng4LoadingSpinnerService) {}

    addSeal(seal: any) {
        console.log("hhhh" + seal);
        console.log('contno', seal.contno);
        console.log('vehicleno', seal.vehicleno);
        let url: string = '/createseal';
        let body = JSON.stringify(seal);
        console.log(body);
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });


    }
    
    updateSealUnlock(seal: any) {
        
        let url: string = '/updateSealUnlock';
        let body = JSON.stringify(seal);
        console.log(body);
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });


    }


    updateSendEmailForTagIdChange(seal: any) {
        
        let url: string = '/updateSendEmailForTagIdChange';
        let body = JSON.stringify(seal);
        console.log('updateSendEmailForTagIdChange',body);
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });


    }

    searchseal() {
        let url: string = '/getallseal';
        return this.http.get(this.baseurl.url + url).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });

    }

    updateseal(seal: any) {
        console.log("@@@@@" + seal);
        let url = '/createseal';
        let body = JSON.stringify(seal);
        console.log(body)
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.put(this.baseurl.url + url + '/' + seal.id, body, {headers}).map((res) => {

            res;
            console.log("res12", JSON.stringify(res));
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });

    }

    findbyid(id: number) {
        let url = "/findsealbyid";
        let body = JSON.stringify({id: id});
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }


    searchexp(term: string, id: number) {
        let url = "/searchexportercompany";
        let body: any
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        if (id != (null && undefined)) {
            body = JSON.stringify({companyName: term, salesContactId: id});
        } else {
            body = JSON.stringify({companyName: term});
        }

        if (!term.trim()) {
            // if not search term, return empty hero array.
            return of([]);
        }
        return this.http.post(this.baseurl.url + url, body, {headers}).pipe(
            tap(_ => console.log(`found exporter matching "${term}"`))

        ).map(res => {res; return res;});
    }
    search_sealby(seal: any) {
        let url = "/searchseal";
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        let body = JSON.stringify(seal);
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }

    generatereport(seals) {
        let url: string = '/generatesealitemreport';
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8').set('responseType', 'arrayBuffer');
        let body = JSON.stringify({printType: 'EXCEL', sealItemVO: seals});
        console.log(body)
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers, responseType: 'text'}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }

    getpof() {
        let url: string = '/getallloactioncode'
        return this.http.get(this.baseurl.url + url).map((res) => {
            res; return res;
        })
    }
    viewSealPO(seal) {
        let url = "/findSealItemByCriteria";
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        let body = JSON.stringify(seal);
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }

    generateSealLockedReport(seals) {
        let url: string = '/generateLockedSealReport';
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8').set('responseType', 'arrayBuffer');
        let body = JSON.stringify({printType: 'pdf', sealItemVO: seals});
        console.log(body)
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers, responseType: 'text'}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }
    generateUsageReport() {
        let url: string = '/generateUsageReport';
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8').set('responseType', 'arrayBuffer');
        let body = JSON.stringify({printType: 'EXCEL'});
        console.log(body)
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers, responseType: 'text'}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }
    
    sealBulkUpload(data) {
        let url: string = "/updateSealDataFromExcel";
        let body = JSON.stringify(data)
        this.spinnerService.show();
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8')
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide();
            return res
        }).catch(
            (error: Response) => {
                this.spinnerService.hide();
                return Observable.throw(error);
            })
    }
   
      updateReallotSeals(seal: any) {
        console.log(seal);
        let url: string = '/updateReallotSeals';
        let body = JSON.stringify(seal);
         this.spinnerService.show();
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res: Response) => {
            res;
            this.spinnerService.hide()
            return res
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }
    
    downloadTemplate(data) {
        let url: string = '/performExcelUploadTemplateDownload';
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8').set('responseType', 'arrayBuffer');
        let body = JSON.stringify((data));
        console.log(body)
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers, responseType: 'text'}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }
      updateBulkSealItem(seal: any) {
        
        let url: string = '/updateBulkSealItem';
        let body = JSON.stringify(seal);
        console.log(body);
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });


    }
    
      searchCurrentTime() {
        let url: string = '/getcurrenttimestamp';
//        let body = JSON.stringify(()));
         this.spinnerService.show();
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        return this.http.post(this.baseurl.url + url, {headers}).map((res: Response) => {
            res;
            this.spinnerService.hide()
            return res
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });

    }
    
     updateSealAmendDetailsByReaderRequest(seal: any) {
        
        let url: string = '/updateSealAmendDetailsByReaderRequest';
        let body = JSON.stringify(seal);
        console.log(body);
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });


    }
    
     updateSealRejectDetailsByReaderRequest(seal: any) {
        
        let url: string = '/updateSealRejectDetailsByReaderRequest';
        let body = JSON.stringify(seal);
        console.log(body);
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });


    }
    
      addReader(data: any) {        
        let url: string = '/createReaderAllocation';
        let body = JSON.stringify(data);
        console.log(body);
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });


    }
   
    updateReader(data: any) {        
        let url = '/updateReaderAllocation';
        let body = JSON.stringify(data);
        console.log(body);
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });

    }

  searchReader(data:any) {
        let url: string = '/searchReaderAllocationByQuery';
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        let body = JSON.stringify(data);
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });

    }
    
    findReader(id: number) {
        let url = "/findReaderAllocation";
        let body = JSON.stringify({id: id});
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }
    
       addPayment(data: any) {        
        let url: string = '/createPayment';
        let body = JSON.stringify(data);
        console.log(body);
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });


    }
   
    updatePayment(data: any) {        
        let url = '/updatePayment';
        let body = JSON.stringify(data);
        console.log(body);
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });

    }

  searchPayment(data:any) {
        let url: string = '/searchPaymentByQuery';
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        let body = JSON.stringify(data);
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });

    }
    
    findPayment(id: number) {
        let url = "/findPayment";
        let body = JSON.stringify({id: id});
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }
    
     addPurchase(data: any) {        
        let url: string = '/createPurchase';
        let body = JSON.stringify(data);
        console.log(body);
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });


    }
   
    updatePurchase(data: any) {        
        let url = '/updatePurchase';
        let body = JSON.stringify(data);
        console.log(body);
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });

    }

  searchPurchase(data:any) {
        let url: string = '/searchPurchaseByQuery';
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        let body = JSON.stringify(data);
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });

    }
    
    findPurchase(id: number) {
        let url = "/findPurchase";
        let body = JSON.stringify({id: id});
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }
    
    searchPaymentParty(data:any) {
        let url: string = '/searchPaymentPartyByQuery';
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        let body = JSON.stringify(data);
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });

    }
    
     createPaymentParty(data: any) {        
        let url: string = '/createPaymentParty';
        let body = JSON.stringify(data);
        console.log(body);
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });


    }
   
    updatePaymentParty(data: any) {        
        let url = '/updatePaymentParty';
        let body = JSON.stringify(data);
        console.log(body);
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });

    }
    
    findPaymentParty(id: number) {
        let url = "/findPaymentParty";
        let body = JSON.stringify({id: id});
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }
    
     generatePurchaseReport(data) {
        let url: string = "/generatePurchaseReport";
        let body = JSON.stringify({
            printType: 'EXCEL',
            purchaseVO: data
        });
        console.log("body", data)
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8').set('responseType', 'arrayBuffer');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers, responseType: 'text'}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }
    
     searchCodeMasterByQuery(data:any) {
        let url: string = '/searchCodeMasterByQuery';
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        let body = JSON.stringify(data);
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });

    }
    
     generatePaymentReport(data) {
        let url: string = "/generatePaymentReport";
        let body = JSON.stringify({
            printType: 'EXCEL',
            paymentVO: data
        });
        console.log("body", data)
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8').set('responseType', 'arrayBuffer');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers, responseType: 'text'}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }
getIceGateLocationcode(data:any) {
        let url: string = '/getIceGateLocationcode';
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        let body = JSON.stringify(data);
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });

    }
    
     viewSealPOList(seal) {
        let url = "/findSealItemByCriteriaList";
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        let body = JSON.stringify(seal);
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }
    
     updateLockSealItem(seal: any) {
        console.log("@@@@@" + seal);
        let url = '/updateLockSealItem';
        let body = JSON.stringify(seal);
        console.log(body)
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            console.log("res12", JSON.stringify(res));
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });

    }
    updateCancelledSealItem(seal: any) {
        console.log("@@@@@" + seal);
        let url = '/updateCancelledSealItem';
        let body = JSON.stringify(seal);
        console.log(body)
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            console.log("res12", JSON.stringify(res));
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });

    }
}



// WEBPACK FOOTER //
// D:/ESealStore_AJS/src/app/service/SealService.ts